export const toast = {
    error: (message) => {
        window.dispatchEvent(new CustomEvent('app-toast', {
            detail: { message, severity: 'error' }
        }));
    },
    success: (message) => {
        window.dispatchEvent(new CustomEvent('app-toast', {
            detail: { message, severity: 'success' }
        }));
    },
    warning: (message) => {
        window.dispatchEvent(new CustomEvent('app-toast', {
            detail: { message, severity: 'warning' }
        }));
    },
    info: (message) => {
        window.dispatchEvent(new CustomEvent('app-toast', {
            detail: { message, severity: 'info' }
        }));
    }
};
